import CardVenue from './CardVenue';

export default CardVenue;
